
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src2815122270/src/vl-app/pages/accessibility.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import useArticle from 'vl-common/src/hooks/useArticle';
import styled from '@emotion/styled';
import Header from '@components/Layouts/Header/Header';

const StyledAccessibilityPage = styled.div`
  .section-layout {
    max-width: 800px;
    margin: 0 auto;
  }

  .login-header {
    border-bottom: 1px solid #707070;

    .nav-panel {
      display: none !important;
    }
  }

  .title {
    font-weight: 600;
    font-size: 25px;
    margin-top: 25px;
    margin-bottom: 25px;
  }

  .login-bottom {
    position: relative;
    width: 100%;
    padding: 21px;
    background: #fff;
    align-items: center;
    display: flex;
    justify-content: center;
    font-weight: bold;
    border-top: 1px solid #707070;
  }
`;

function Accessibility() {
  const { t } = useTranslation('common');
  const article = useArticle('accessibility', true);

  return (
    <StyledAccessibilityPage>
      <Header pageType="login" className="login-header" pageTitle={t('AccessibilityStatement')} />
      <section className="section-layout">
        <h1 className="title">{t('AccessibilityStatement')}</h1>

        <main className="container" id="page-content">
          <Row gutter={[0, 30]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="app-table">
              {article && (
                <div className="accessibility-statement" dangerouslySetInnerHTML={{ __html: article.body }} />
              )}
            </Col>
          </Row>
        </main>
      </section>
    </StyledAccessibilityPage>
  );
}

export default Accessibility;
export const Route = createFileRoute('/accessibility')({ component: Accessibility });
